import _ from 'lodash'
import { runInAction, reaction } from 'mobx'

class BaseModel {
  constructor(fields) {
    if (!_.isEmpty(fields)) {
      this.setField = (field) => v => {
        runInAction(() => {
          const f = _.find(fields, fd => fd === field || _.get(fd, 'field') === field)
          const path = _.isObject(f) ? f.path : null
          if (path) {
            _.set(this, path, v)
          } else {
            this[field] = v
          }
        })
      }

      this.setTrimField = (field) => v => {
        this.setField(field)(v ? v.trim() : '')
      }
    }
  }

  applyOnChangeHook(fields, onChangeHook, isAllHook = false) {
    if (!_.isEmpty(fields) && onChangeHook) {
      if (isAllHook) {
        reaction(() => {
          const state = {}
          _.each(fields, field => {
            if (_.isObject(field)) {
              state[field.field] = _.get(this, field.path, null)
            } else {
              state[field] = _.get(this, field)
            }
          })
          return state
        }, state => {
          onChangeHook(state)
        })
      }

      _.each(fields, field => {
        const f = _.find(fields, fd => fd === field || _.get(fd, 'field') === field)

        reaction(() => ({
          field,
          value: !_.get(_.isObject(f) ? _.get(this, f.path, null) : this[f], 'slice', null) ?
            _.isObject(f) ? _.get(this, f.path, null) : this[f] :
            JSON.stringify(_.isObject(f) ? _.get(this, f.path, null) : this[f])
        }), state => {
          onChangeHook(state)
        })
      })
    }
  }

  applyData = data => {
    runInAction(() => {
      _.each(data, (value, path) => {
        _.set(this, path, value)
      })
    })
  }
}

export default BaseModel
